(function(angular){
	'use strict';
	
	angular.module('mediaGalleryModule', [
		'coreModule',
		'youtube-embed'
	]);

})(window.angular);